import React from "react";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "../Accounting/Data/AccountCRUDConfig.json";
import PageHeader from "../../components/PageHeader";
import { Box } from "@mui/material";
function AccountPage() {
  return (
    <Box sx={{ display: "flex" }}>
    <Box sx={{ flexGrow: 1, marginTop:0, marginLeft: 15,  marginRight: 15, marginBottom:15}} >
   
      <PageHeader pageTitle="Manage Account Type" />
      <CrudManager
        data={schema}
        actionBtnName="Add Account Type"
        createFormTitle="Add Account Type"
        updateFormTitle="Update Account Type"
      />
   </Box>
   </Box>
  );
}

export default AccountPage;
